import React from 'react';

import css from './PrayerHubsFeed.module.scss';

interface Props {
  isActive?: boolean;
}

export const CREDITS_SLIDE_ID = 'credits' as const;

export type CreditsSlideItem = { _id: typeof CREDITS_SLIDE_ID };

export const CREDITS_SLIDE: CreditsSlideItem = { _id: CREDITS_SLIDE_ID };

export function isCreditsSlide(data: unknown): data is CreditsSlideItem {
  return typeof data === 'object' && data != null && '_id' in data && data._id === CREDITS_SLIDE_ID;
}

export function CreditsSlide(_props: Props) {
  return (
    <div className={css.creditsSlide}>
      <div className={css.feedCredit} dir="ltr">
        <p className={css.feedCreditLine}>
          Built by{' '}
          <a className={css.feedCreditBrand} href="https://www.rabbi.co.il/" target="_blank" rel="noopener noreferrer">
            Rabbi
          </a>
        </p>
        <p className={css.feedCreditTagline}>UI/UX &amp; development</p>
      </div>
    </div>
  );
}
